import { inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { ENVIRONMENT_TOKEN } from '../injection-tokens/environment.token';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private environment = inject(ENVIRONMENT_TOKEN);
  private allowNavigation = false;
  private router = inject(Router);

  public navigateToHomePage(): void {
    this.router.navigate(['/']);
  }

  public navigateToUrl(url: string): void {
    this.router.navigate([url]);
  }

  public navigateToLexipoortLoginPage(): void {
    this._navigateToAuthority('/Account/Login');
  }

  public navigateToLexipoortDashboard(): void {
    this._navigateToAuthority('/Account/dashboard');
  }

  public enableBypass() {
    this.allowNavigation = true;
  }

  public shouldBypass(): boolean {
    const result = this.allowNavigation;
    this.allowNavigation = false;
    return result;
  }

  private _navigateToAuthority(path = ''): void {
    // document.location.href = `${this.environment.authorityUrl}${path}`;
  }
}
